export function prepareData(values, stageIndex, defaultClientSearch = {}) {
  return {
    stageIndex,
    DefaultPropertySearchPreferences: {
      ...defaultClientSearch,
      Locations: values.locations?.length ? values.locations : undefined,
    },
  };
}
